import { env } from '../env';

export const device = !env.isSSR()
  ? {
      isMobile:
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        ),
      isIOS: (() => {
        const { userAgent, maxTouchPoints } = navigator;
        const hasMultiTouch = maxTouchPoints > 1;

        const isIOSDevice = /iPad|iPhone|iPod/i.test(userAgent);
        const isMacWithTouch =
          /Macintosh|MacIntel/i.test(userAgent) && hasMultiTouch;

        // Detect iOS: includes iPhones with outdated userAgent quirks and Mac devices with touch capabilities
        // For Ex: iPhone 7 IOS 15.2 has Macintosh userAgent
        return isIOSDevice || isMacWithTouch;
      })(),
    }
  : {};
